import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    routing: false,
    loading: false,
    saving: false,
    deleting: false,

    auth: {
      success: false,
      user: {},
      role: {}
    },
    notification: {
      show: false,
      css: "",
      text: "",
      timeout: null
    }
  },

  mutations: {},
  actions: {}
});
